export default "__VITE_ASSET__C5$Nh9wZ__"